export default "__VITE_PUBLIC_ASSET__f4f2bb0a__"